export const isFromYear2024 = (dateStr: string): boolean => {
  const date = new Date(dateStr);
  return date.getFullYear() === 2024;
};
